var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRoseStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.965394
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1977 5.15883C20.2762 4.73827 20.4994 4.35843 20.8285 4.08508C21.1576 3.81174 21.572 3.66211 21.9998 3.66211C22.4277 3.66211 22.842 3.81174 23.1712 4.08508C23.5003 4.35843 23.7234 4.73827 23.802 5.15883L25.7288 15.3485C25.8657 16.0729 26.2177 16.7393 26.7391 17.2606C27.2604 17.7819 27.9267 18.134 28.6512 18.2708L38.8408 20.1977C39.2614 20.2762 39.6412 20.4994 39.9146 20.8285C40.1879 21.1576 40.3376 21.572 40.3376 21.9998C40.3376 22.4277 40.1879 22.842 39.9146 23.1712C39.6412 23.5003 39.2614 23.7234 38.8408 23.802L28.6512 25.7288C27.9267 25.8657 27.2604 26.2177 26.7391 26.7391C26.2177 27.2604 25.8657 27.9267 25.7288 28.6512L23.802 38.8408C23.7234 39.2614 23.5003 39.6412 23.1712 39.9146C22.842 40.1879 22.4277 40.3376 21.9998 40.3376C21.572 40.3376 21.1576 40.1879 20.8285 39.9146C20.4994 39.6412 20.2762 39.2614 20.1977 38.8408L18.2708 28.6512C18.134 27.9267 17.7819 27.2604 17.2606 26.7391C16.7393 26.2177 16.0729 25.8657 15.3485 25.7288L5.15883 23.802C4.73827 23.7234 4.35843 23.5003 4.08508 23.1712C3.81174 22.842 3.66211 22.4277 3.66211 21.9998C3.66211 21.572 3.81174 21.1576 4.08508 20.8285C4.35843 20.4994 4.73827 20.2762 5.15883 20.1977L15.3485 18.2708C16.0729 18.134 16.7393 17.7819 17.2606 17.2606C17.7819 16.7393 18.134 16.0729 18.2708 15.3485L20.1977 5.15883Z",
    stroke: "#FB64B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6665 3.66699V11.0003",
    stroke: "#FB64B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3333 7.33301H33",
    stroke: "#FB64B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33317 40.3333C9.35821 40.3333 10.9998 38.6917 10.9998 36.6667C10.9998 34.6416 9.35821 33 7.33317 33C5.30813 33 3.6665 34.6416 3.6665 36.6667C3.6665 38.6917 5.30813 40.3333 7.33317 40.3333Z",
    stroke: "#FB64B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoseStar);
export default __webpack_public_path__ + "static/media/ic_rose_star.f1a653893a70c984ad4f9f2f875f7575.svg";
export { ForwardRef as ReactComponent };